import axios from 'axios'
import qs from 'qs'

axios.defaults.timeout = 30000;                        //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';        //配置请求头
axios.defaults.baseURL = 'https://api.ds.md.haiweikexin.com';   //配置接口地址
//axios.defaults.baseURL = 'http://192.168.0.9/kx_library/public/api/v1/';  
//axios.defaults.baseURL = 'http://proxy.jiankanghao.net:50223';
 
 
//GET传参序列化
axios.interceptors.request.use((config) => {
    if (config.method === 'get') {
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
        config.paramsSerializer = function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axios